import React, { Component } from 'react'
import './krishak.css';
import Utilities from '../../global/Utilities';
import AddImages from '../common/AddImages';
import GpsCoordinates from '../common/GpsCoordinates';
import { ADD_KRISHAK_SCREEN } from '../../global/Constants';
import ApiServices from '../../providers/ApiServices';

class LastStep extends Component {

    constructor(props) {
        super(props)

        this.state = {
            images: [],
            imagesFiles: [],
            delete_krishak_image: [],
            latlong: null,
            fields: {
                remarks: "",
            },
        }
    }

    componentDidMount() {

        let krishakData = this.props.krishakData;
        Utilities.LogPrint("componentDidMountLastStep", krishakData);
        if (krishakData) {
            this.setState({
                fields: {
                    remarks: krishakData.remark,
                },
                images: krishakData.krishak_images,
                latlong: {
                    latitude: krishakData.latitude,
                    longitude: krishakData.longitude
                }
            }, () => {
                this.updateNextButton();
            })
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        this.updateNextButton();
    };

    updateNextButton = () => {

        const { images, latlong, imagesFiles, delete_krishak_image } = this.state;
        const remarks = this._getFieldValue("remarks", "");
        // let isEnable = latlong !== null && images && images.length !== 0;
        // let isEnable = images && images.length !== 0;
        let isEnable = true;

        let mobileImages = [];
        if (images !== undefined) {
            for (var i = 0; i < images.length; i++) {
                let image1 = images[i];
                mobileImages.push({
                    image_url: (image1.image_url === undefined) ? image1.path : image1.image_url,
                    image_name: (image1.image_name === undefined) ? Math.random().toString(36).substring(7) : image1.image_name
                });
            }
        }


        if (isEnable) {
            var last_step = {
                images: mobileImages,
                latlong: latlong,
                remarks: remarks,
                delete_krishak_image,
                imagesFiles
            };
        }
        Utilities.LogPrint("last_step_last_step", last_step);
        this.props._handleNextButton(isEnable, last_step, "last_step");
    }

    deleteKrishakImageApi = (item) => {
        if (item.id !== 0) {
            let delete_krishak_image = this.state.delete_krishak_image.slice();
            delete_krishak_image.push(item.id);
            this.setState({
                delete_krishak_image
            })
        }
        var params = JSON.stringify({
            krishak_image_id: item.id,
        });
        try {
            ApiServices.deleteKrishakImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteKrishakImageApi", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteKrishakImageApi-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteKrishakImageApi-error", error);
        }
    }

    getCoordinates = (latlong) => {
        this.setState({
            latlong
        }, () => {
            this.updateNextButton();
        })
    }

    loaderCallback = (isLoading) => {
        this.setState({ isLoading })
    }

    handleAddImages = (e, images, selectedFiles) => {
        this.setState({ images, imagesFiles: selectedFiles }, () => {
            this.updateNextButton();
        });
        Utilities.LogPrint("Images", selectedFiles);
    }


    render() {
        const { isVisible } = this.props;
        const { images, latlong } = this.state;
        const remarks = this._getFieldValue("remarks", "");
        return (
            <div className={isVisible ? "row krishak-tab-body last-step-body" : "row krishak-tab-body last-step-body d-none"}>
                <div className="col-12">
                    <div className="form-group">
                        <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.REMARKS} <span className="font-weight-normal">({ADD_KRISHAK_SCREEN.IF_ANY})</span></label>
                        <textarea className="form-control" value={remarks} rows="7" onChange={this._handleValueChange.bind(this, "remarks")}></textarea>
                    </div>

                    <AddImages deleteActivityImageApi={this.deleteKrishakImageApi} imagePaths={images} handleAddImages={this.handleAddImages} />
                    <GpsCoordinates loaderCallback={this.props.loaderCallback} latlong={latlong} getCoordinates={this.getCoordinates} />
                </div>
            </div>

        )
    }
}

export default LastStep